export default __webpack_public_path__ + "static/media/trash.78674e72.svg";